module.exports = __webpack_public_path__ + "static/img/comp.1261964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comp.png
// module id = P0jK
// module chunks = 0